import './media-viewer.less';

import register from '@kpsys/angularjs-register';
import RepositoryService from './repository.service';
import MediaViewerService from './media-viewer.service';
import MediaViewerController from './media-viewer.controller';
import KpMediaViewerFilesComponent from './kp-media-viewer-files/kp-media-viewer-files.component';
import KpMediaViewerDirectoriesComponent from './kp-media-viewer-directories/kp-media-viewer-directories.component';
import KpDirectoryTreeComponent from './kp-directory-tree/kp-directory-tree.component';
import KpMediaViewerViewerComponent from './media-viewer-viewer/kp-media-viewer-viewer.component';
import KpMediaViewerSearchComponent from './kp-media-viewer-search/kp-media-viewer-search.component';
import searcherFactory from './searcher.factory';

/**
 * @ngdoc module
 * @name portaro.media-viewer
 * @module portaro.media-viewer
 */

export default register('portaro.media-viewer')
    .factory(searcherFactory.factoryName, searcherFactory)
    .service(RepositoryService.serviceName, RepositoryService)
    .service(MediaViewerService.serviceName, MediaViewerService)
    .controller(MediaViewerController.controllerName, MediaViewerController)
    .component(KpDirectoryTreeComponent.componentName, KpDirectoryTreeComponent)
    .component(KpMediaViewerDirectoriesComponent.componentName, KpMediaViewerDirectoriesComponent)
    .component(KpMediaViewerFilesComponent.componentName, KpMediaViewerFilesComponent)
    .component(KpMediaViewerViewerComponent.componentName, KpMediaViewerViewerComponent)
    .component(KpMediaViewerSearchComponent.componentName, KpMediaViewerSearchComponent)
    .name();
